import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type PortalState = 'tspsc' | 'appsc';

interface PortalStore {
  portal: PortalState;
  setPortal: (portal: PortalState) => void;
}

export const usePortal = create<PortalStore>()(
  persist(
    (set) => ({
      portal: 'tspsc',
      setPortal: (portal) => set({ portal }),
    }),
    {
      name: 'portal-storage',
    }
  )
);
